import { useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import landingStyle from "../styles/landing.module.scss";
import {
  passwordErrorMessage,
  resetPassword,
} from "../utilities/passwordAccount";

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = useMemo(
    () => String(searchParams.get("token") || "").trim(),
    [searchParams],
  );
  const isInvite = searchParams.get("invite") === "1";
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [completed, setCompleted] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!token) {
      setMessage("This reset link is missing its token.");
      return;
    }

    if (password.length < 8) {
      setMessage("Password must be at least 8 characters.");
      return;
    }

    if (password !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      await resetPassword({ token, password });
      setCompleted(true);
    } catch (error) {
      setMessage(
        passwordErrorMessage(
          error,
          "That reset link is invalid or has expired.",
        ),
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={landingStyle.loginView}>
      <form className={landingStyle.loginForm} onSubmit={handleSubmit}>
        <div className={landingStyle.formHeader}>
          <p className={landingStyle.stateLabel}>Password</p>
          <h3>
            {completed
              ? "Password saved"
              : isInvite
                ? "Create your password"
                : "Choose a new password"}
          </h3>
          <p>
            {completed
              ? "You can now sign in with your new password."
              : isInvite
                ? "This invite link expires seven days after it was sent."
                : "This link expires one hour after it was sent."}
          </p>
        </div>

        {completed ? (
          <Link className={landingStyle.textLink} to="/">
            Go to sign in
          </Link>
        ) : (
          <>
            <div className={landingStyle.loginInputGroup}>
              <label htmlFor="reset-password">New password</label>
              <input
                id="reset-password"
                type="password"
                autoComplete="new-password"
                placeholder="At least 8 characters"
                value={password}
                onChange={(event) => {
                  setPassword(event.target.value);
                  setMessage("");
                }}
              />
              <label htmlFor="reset-confirm-password">Confirm password</label>
              <input
                id="reset-confirm-password"
                type="password"
                autoComplete="new-password"
                placeholder="Repeat password"
                value={confirmPassword}
                onChange={(event) => {
                  setConfirmPassword(event.target.value);
                  setMessage("");
                }}
              />
              {message ? (
                <div className={landingStyle.loginErrorMessage}>{message}</div>
              ) : null}
            </div>
            <button
              className={`${landingStyle.button} ${
                !password ? landingStyle.buttonDisabled : ""
              }`}
              type="submit"
              disabled={!password || loading}
            >
              {loading ? "Saving..." : "Save password"}
            </button>
            <Link className={landingStyle.textLink} to="/">
              Back to sign in
            </Link>
          </>
        )}
      </form>
    </div>
  );
}

export default ResetPassword;
